
export enum JournodexEnumTypes {
    mediaType = 'mediatype',
    productType = 'producttype',
    targetGroup = 'targetgroup',
    productFrequency = 'productfrequency',
    marketSector = 'marketsector',
    researchFrequency = 'researchfrequency',
    handleType = 'handletype',
    jobRole = 'jobrole',
    coverageFocus = 'coveragefocus',
    targetAudience = 'targetaudience',
    language = 'language',
    DMA = 'dma',
    circulationType = 'circulationtype',
    liveness = 'liveness',
    mediaMarket = 'mediamarket'
}
